module.exports = __webpack_public_path__ + "static/media/kidneys.47323225.svg";